var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.359,
    height: 16.001,
    viewBox: "0 0 16.359 16.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_alt_FILL0_wght400_GRAD0_opsz48",
    d: "M160.013,272a.982.982,0,0,1-1-1v-6l-5.975-7.626a.756.756,0,0,1-.1-.9.822.822,0,0,1,.775-.475h14.6a.821.821,0,0,1,.775.475.756.756,0,0,1-.1.9L163.013,265v6a.982.982,0,0,1-1,1Zm1-6.9,6-7.6h-12ZM161.013,265.1Z",
    transform: "translate(-152.833 -256)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters_icon.2786b254998243144225c736f8a5eb07.svg";
export { ForwardRef as ReactComponent };